import { render, staticRenderFns } from "./OperaCmmWindow.vue?vue&type=template&id=60952512&scoped=true&"
import script from "./OperaCmmWindow.vue?vue&type=script&lang=js&"
export * from "./OperaCmmWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaCmmWindow.vue?vue&type=style&index=0&id=60952512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60952512",
  null
  
)

export default component.exports